<template>
  <validation-provider :rules="rules" :name="`${tab}.${field}`" v-slot="{ valid, errors, changed }" :class="className">
    <b-input-group :append="appendText">
      <b-button :id="`${tab}.${field}`" v-if="helpText" class="help-icon">?</b-button>
      <b-popover v-if="helpText" :target="`${tab}.${field}`" triggers="hover" placement="top">
        <template v-slot:title>Info</template>
        {{helpText}}
      </b-popover>
      <b-form-input
        type="text"
        @blur="updateField"
        :state="onValidateField(valid, errors, changed)"
        :placeholder="placeholder"
        :label="field"
        v-model="initValue"
        v-mask="mask"
      ></b-form-input>
      <b-form-invalid-feedback class="invalid-feedback">{{ errors[0] }}</b-form-invalid-feedback>
    </b-input-group>
  </validation-provider>
</template>

<script>
  import createNumberMask from 'text-mask-addons/dist/createNumberMask'
  import { ValidationProvider } from 'vee-validate'
  import { validateField } from '@/helpers/formHelper.js'
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        mask: null,
        initValue: ''
      }
    },
    created () {
      this.initValue = this.getField

      if (this.isYearFormat() || this.isPercentageField()) {
        this.mask = this.format
      } else {
        this.mask = createNumberMask({
          prefix: '',
          allowDecimal: true,
          decimalLimit: this.getDecimal(),
          includeThousandsSeparator: true,
          allowNegative: false,
          thousandsSeparatorSymbol: "'",
          requireDecimal: false
        })
      }
    },
    components: {
      ValidationProvider
    },
    props: {
      tab: {
        type: String,
        required: true
      },
      helpText: String,
      format: String,
      field: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      placeholder: String,
      className: String,
      rules: String,
      appendText: String
    },
    computed: mapState({
      getField (state) {
        const { tab, field } = this
        return state.calculator.formData[tab][field]
      }
    }),
    methods: {
      updateField (e) {
        const { tab, field } = this
        const { value } = e.target
        const replacedValue = value.replace(/'/g, '').replace(/\.$/, '')

        this.$store.commit('calculator/SET_FORMFIELD_VALUE', {
          tab,
          field,
          value: replacedValue
        })
      },
      getDecimal () {
        if (this.format && this.format.includes('.')) {
          const format = this.format.split('.')[1].length
          return format
        }
        return 0
      },
      isYearFormat () {
        return this.format === '####'
      },
      isPercentageField () {
        return this.format === '###'
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .invalid-feedback{
    order: 3;
  }
</style>
